export default {
  title: 'Warlock demons',
  content: ['Felhunter now gains mana from auto attacks.'],
}
